import {decode as base64_decode, encode as base64_encode} from 'base-64';
import {useEffect, useState} from 'react';
import {ButtonCopyToClipboard} from '../ButtonCopyToClipboard';
import './Base64Converter.css';
export const Base64Converter = () => {
	const [encodeSource, setEncodeSource] = useState<string>('');
	const [encodeDestination, setEncodeDestination] = useState<string>('');
	const [decodeSource, setDecodeSource] = useState<string>('');
	const [decodeDestination, setDecodeDestination] = useState<string>('');
	useEffect(() => {
		try {
			setEncodeDestination(base64_encode(encodeSource));
		} catch (error) {
			console.log("Don't encode that..." + encodeSource);
		}
	}, [encodeSource]);

	useEffect(() => {
		try {
			setDecodeDestination(base64_decode(decodeSource));
		} catch (error) {
			setDecodeDestination("Don't decode that rubbish...");
		}
	}, [decodeSource]);
	return (
		<div className='panel '>
			<div>
				<h2>Base64 encode / decode</h2>
			</div>
			<div className='data-encode base64-panel'>
				<div className='encode-source'>
					<input
						autoFocus
						placeholder='Encode this string'
						value={encodeSource}
						onChange={(e) => {
							setEncodeSource(e.target.value);
						}}
					/>
				</div>
				<div className='encode-destination'>
					<input value={encodeDestination} disabled={true} />
				</div>
				<div>
					<ButtonCopyToClipboard key='copy-encode' text={encodeDestination} />
				</div>
			</div>

			<div className='data-decode'>
				<div className='decode-source'>
					<input
						placeholder='Decode this string'
						value={decodeSource}
						onChange={(e) => {
							setDecodeSource(e.target.value);
						}}
					/>
				</div>
				<div className='encode-destination'>
					<input value={decodeDestination} disabled={true} />
				</div>
				<div>
					<ButtonCopyToClipboard key='copy-dencode' text={decodeDestination} />
				</div>
			</div>
		</div>
	);
};
